import { SD, SupportedMessageFormats } from "../../../Contracts";
import { RequestFormatter } from "../../../Common";
import { STR_ERRORS } from "../../Strings";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
export function SDQRequestFormatter(query) {
    const id = SDQuerySubscribersStore.getQueryID(query);
    let message = "";
    if (query.name === SD.QueryTypes.Unsubscribe) {
        message = RequestFormatter(SupportedMessageFormats["jsonrpc2.0"], query.name, {}, query.params.id);
    }
    else {
        if (typeof id === "undefined") {
            throw new Error(STR_ERRORS.SDQRequestFormatRequiresActiveQuery);
        }
        message = RequestFormatter(SupportedMessageFormats["jsonrpc2.0"], query.name, query.params, id);
    }
    return message;
}
//# sourceMappingURL=SDQRequestFormatter.js.map